import {getMethod} from '~/api'

async function get() {
    return await getMethod('/cms/layout-settings')
}

export {get}
